// src/components/Dashboard.js
import React, { useState } from "react";
import ProjectTable from "./ProjectTable";
import BookingsTable from "./BookingsTable";
import AddProjectForm from "./AddProjectForm";
import { useLogout } from "../hooks/useLogout";
import "../styles/Dashboard.css";
import ProjectPlotViewer from "./ProjectPlotViewer";

const Dashboard = () => {
  const [activeView, setActiveView] = useState("projects");
  const logout = useLogout();

  const renderView = () => {
    switch (activeView) {
      case "addProject":
        return <AddProjectForm />;
      case "bookings":
        return <BookingsTable />;
      case "editPlots":
        return <ProjectPlotViewer />
      default:
        return <ProjectTable />;
    }
  };

  return (
    <div className="dashboard-container">
      <aside className="sidebar">
        <h2>Admin Panel</h2>
        <button
          onClick={() => setActiveView("projects")}
          className={activeView === "projects" ? "active" : ""}
        >
          View Projects
        </button>
        <button
          onClick={() => setActiveView("addProject")}
          className={activeView === "addProject" ? "active" : ""}
        >
          Add New Project
        </button>
        <button
          onClick={() => setActiveView("editPlots")}
          className={activeView === "editPlots" ? "active" : ""}
        >
          Edit Project Plots
        </button>
        <button
          onClick={() => setActiveView("bookings")}
          className={activeView === "bookings" ? "active" : ""}
        >
          View Bookings
        </button>
        <button className="logout-btn" onClick={logout}>Logout</button>
      </aside>

      <main className="main-content">{renderView()}</main>
    </div>
  );
};

export default Dashboard;
